<div class="update-banner" *ngIf="showUpdateBanner">
  <div class="update-banner-content">
    <span class="update-message">A new version of the application is available.<br>
Please click the Refresh button to update the system and return to the homepage.<br>
Your project has already been saved.</span>
    <button class="update-refresh-button" (click)="refreshPage()">Refresh</button>
    <button class="update-dismiss-button" (click)="dismissBanner()" title="Dismiss">×</button>
  </div>
</div>
<div class="app-content" [class.with-banner]="showUpdateBanner">
  <router-outlet></router-outlet>
</div>